import React from "react";
import OrderDTO from "@/dto/order/OrderDTO";
import { ShipValidationRule, ShipValidationRuleKey } from "../type";
import { buildValidationSuccessfulResult } from "../util";
import { confirm } from "@/utils";
import ShopType from "@/enum/ShopType";
import type GlobalStore from "@/store";
import { isAnyOrderNotInputtedWaybillNo } from "@/utils/OrderUtils";

export default async function validateManualOrderWaybillNo(
    orders: OrderDTO[],
    rule: ShipValidationRule,
    globalStore: typeof GlobalStore,
) {
    if (!rule[ShipValidationRuleKey.checkManualOrderWaybillNo]) return buildValidationSuccessfulResult(orders);

    for (const order of orders) {
        const shop = globalStore.shopMapping.get(order.shopId);

        if ([ShopType.MANUAL, ShopType.INDEPENDENT_MANUAL].includes(shop?.type)) {
            if (isAnyOrderNotInputtedWaybillNo([order])) {
                await confirm("所选订单中某些订单还没有录入运单号，是否继续设为已发货？");

                /** 如果继续设为已发货，则不用再多次提示 */
                break;
            }
        }
    }

    return buildValidationSuccessfulResult(orders);
}
